module.exports = __webpack_public_path__ + "static/media/2-en.ae75b5bc.svg";